import React from 'react';
import Stack from 'src/app/atoms/Layout/Stack/Stack';
import Button from 'src/app/atoms/Button/Button';
import FreeTrialBlockWithAbsolutePositionedCollage from 'src/app/molecules/FreeTrialBlockWithAbsolutePositionedCollage/FreeTrialBlockWithAbsolutePositionedCollage';

const FreeTrialBlockWithFloatingAsset = (): JSX.Element => {
  return (
    <FreeTrialBlockWithAbsolutePositionedCollage
      headlineProps={{
        type: 'heading',
        size: 'xl',
        text: 'Start your free trial',
      }}
      checkItemTextListWithActionsProps={{
        checkItemTextListProps: {
          checkItems: [
            '14 days. No credit card required',
            'Everything you need to launch a paid community or course',
            'AI Cohost to help you design an offer worth $48/mo',
          ],
          checkItemProps: {
            size: 'lg',
            type: 'default',
            color: 'primary',
          },
        },
        actions: (
          <Stack maxWidth='width-fit-content'>
            <Button
              variant='primary'
              size='xl'
              href='https://cohost.mn.co/?plan=free-trial'
            >
              Try Mighty for Free
            </Button>
          </Stack>
        ),
      }}
    />
  );
};

export default FreeTrialBlockWithFloatingAsset;
